header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: var(--size-4) 0;
}

h1 {
  display: flex;
  gap: .15em;
  align-items: center;
  margin: 0;
}

[part="brand-logo"] {
  height: var(--size-7);
}

[part="github-link"] {
  display: flex;
  align-items: center;

  svg {
    fill: var(--color-5);

    &:hover {
      fill: var(--color-2);
    }
  }
}

[part="header-end"] {
  display: flex;
  align-items: center;
}

@media (width < 768px) {
  [part="brand-logo"] {
    height: var(--size-5);
  }

  h1 {
    font-size: var(--size-5);
  }
}
